export const OptionApis = [
    {
        value: 1,
        label: "API sinh mã hồ sơ",
    },
    {
        value: 2,
        label: "API gửi sang MCDT",
    },
    {
        value: 3,
        label: "API nhận kết quả hồ sơ trả về",
    },
    {
        value: 4,
        label: "API nhận yêu cầu xác minh",
    },
    {
        value: 5,
        label: "API trả kết quả xác minh",
    },
];

export const OptionStatusJudicial = [
    {
        value: 1,
        label: "Không thành công",
        tag: <div style={{ color: "#ff0000", background: "#FFD9D9", padding: "4px", borderRadius: "4px", textAlign: "center" }}>Không thành công</div>,
        tagReverse: <div style={{ color: "#ff0000", background: "#FFD9D9", padding: "4px", borderRadius: "4px", textAlign: "center" }}>Không thành công</div>,
    },
    {
        value: 0,
        label: "Thành công",
        tag: <div style={{ color: "#00FF00 ", background: "#D9FFD9", padding: "4px", borderRadius: "4px", textAlign: "center" }}>Thành công</div>,
        tagReverse: <div style={{ color: "#00FF00 ", background: "#D9FFD9", padding: "4px", borderRadius: "4px", textAlign: "center" }}>Thành công</div>,
    },
];
